export const DATA_ADDRESS = 'https://cex.intelligentprotocols.com';
export const WEBSOCKET_ADDRESS = 'https://ws.intelligentprotocols.com';
export const SYMBOLS_API_URL = 'https://cex.intelligentprotocols.com'

export const NO_OF_CANDLES = 300;
export const LENGTH_TO_SHOW = 300;
export const TOOLTIP_PADDING_LEFT = 8;
export const TOOLTIP_PADDING_TOP = 45;
export const TOOLTIP_HEIGHT = 40;
